import { render, staticRenderFns } from "./layout-contractor.vue?vue&type=template&id=4d8bc99c&"
import script from "./layout-contractor.vue?vue&type=script&lang=js&"
export * from "./layout-contractor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports